import styled from 'styled-components';
import {
  darken,
} from 'polished';
import {
  Flex,
  SVG,
  icons,
} from 'web-styled';

const darked = props => darken(0.05, props.theme.colors.primary);

export const Header = styled(Flex)`
  background: ${props => props.theme.colors.bgBlack};
  width: 100%;
  flex: 0 0 64px;

  @media print {
    display: none;
  }
`;

export const Search = styled(Flex).attrs({
  align: 'center',
  justify: 'center',
})`
  background: #2f3538;
  padding: 16px 12px;
  white-space: nowrap;
  width: 100%;
`;

export const Input = styled.input`
  width: 100%;
  border: none;
  outline: none;
  height: 32px;
  border-radius: 50px 0 0 50px;
  background: #343a3d;
  transition: background 0.2s linear 0.2s, color 0.2s linear 0.2s;
  padding: 6px 12px;
  color: #fff;
  font-size: 14px;
  line-height: 1.42857143;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, .075);
  box-sizing: border-box;

  &::placeholder {
    color: rgba(255, 255, 255, 0.25);
    opacity: 1;
  }

  &:focus,
  &:active {
    color: #fff !important;
    background: #23292b;
    box-shadow: none;
    & + button {
      color: #fff !important;
      background: #23292b;
    }
  }
`;

export const SearchButton = styled.button`
  color: rgba(255, 255, 255, 0.25);
  font-size: 14px;
  font-weight: normal;
  line-height: 1.42857143;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  height: 32px;
  padding: 6px 12px;
  margin-bottom: 0;
  border: none;
  outline: none;
  border-radius: 0 50px 50px 0;
  background: #343a3d;
  transition: background 0.2s linear 0.2s, color 0.2s linear 0.2s;
  cursor: pointer;
`;

export const Dropdown = styled(Flex).attrs({
  align: 'center',
  justify: 'center',
})`
  position: relative;
  width: ${props => props.width || '64px'};
  height: 64px;
  background: ${props => (props.isOpen ? darked(props) : '#23292b')};
`;

export const Trigger = styled(Flex).attrs({
  align: 'center',
  justify: 'center',
})`
  color: ${props => (props.isOpen ? '#fff' : '#a6a9aa')};
  height: 46px;
  cursor: pointer;
`;

export const Avatar = styled.div`
  height: 42px;
  width: 42px;
  border-radius: 50%;
  cursor: pointer;
  background-size: contain;
  background-color: ${props => props.theme.colors.primary};
  background-image: url(${props => props.avatar || icons.clientAvatarWhitePlaceHolder});
  background-repeat: no-repeat;
  background-position: center center;
  border: 2px solid #fff;
  user-select: none;
`;

export const Actions = styled.div`
  min-width: ${props => props.minWidth || '160px'};
  padding: 14px 0;
  margin-top: 9px;
  margin-right: ${props => props.mr || 0}px;
  background: ${darked};
  z-index: 999;
  box-sizing: border-box;
  box-shadow: 0 6px 12px rgba(0, 0, 0, .175);
`;

export const Action = styled(Flex).attrs({
  spacing: 10,
  padding: '0 15px',
})`
  color: #fff;
  font-size: 12px;
  height: 39px;
  line-height: 39px;
  cursor: pointer;

  &:hover {
    background: ${props => darken(0.07, props.theme.colors.primary)};

    span {
      opacity: 1;
    }
  }
`;

export const ActionIcon = styled.span`
  height: 22px;
  width: 20px;
  opacity: 0.65;
  position: relative;
  top: 7px;
  left: 7px;
  background-repeat: no-repeat;
  ${(props) => {
    switch (props.icon) {
      case 'payment':
        return `
          background-size: contain;
          background-position: center;
        `;
      case 'referral':
        return `
          background-size: 100% 100%;
        `;
      case 'signout':
        return `
          background-size: 14px;
          background-position: center;
        `;
      default:
        return `
          background-size: cover;
          background-position: left top;
        `;
    }
  }}
`;

export const SVGIcon = styled.span`
  position: relative;
  left: 0px;
  top: 4px;
  opacity: 0.65;

  svg {
    height: 18px !important;
    width: 16px !important;
  }
`;

export const PlusCircle = styled(SVG.PlusCircle).attrs(
  props => ({
    stroke: '#ffffff',
    width: '19px',
    height: '23px',
    fill: props.isOpen ? 'none' : props.theme.colors.success,
  }),
)``;

export const HelpIcon = styled.div`
  width: 21px;
  height: 23px;
  opacity: ${props => (props.isOpen ? 1 : 0.8)};
  background-size: cover;
  background-image: url(${icons.sidebarHelp});
`;
